import React from 'react'
import AcceptInviteForm from '@/components/auth/AcceptInviteForm'

function AcceptInvitePage(): React.JSX.Element {
  return (
    <div className="auth-page">
      <AcceptInviteForm />
    </div>
  )
}

export default AcceptInvitePage
